import { gql } from '__generated__';

export const EventSettingsFieldsFragment = gql(`
  fragment EventSettingsFields on Event {
    id
    title
    description
    checkout_description
    usp_1
    usp_2
    usp_3
    previous_edition {
      id
    }
    email
    website_url
    location {
      id
      title
      description
      address
      country
      coordinates
    }
    locale
    logo {
      id
      url
    }
    photos {
      id
      position
      file {
        id
        url
      }
    }
    brand_color
    invoice_prefix
    vat_number
    terms {
      id
      url
    }
    supporta_url
    terms_url
    terms_text
    start_date
    end_date
    private
    private_teams
    min_team_size
    max_team_size
    allow_teams
    age_threshold_date
    confirmation_text
    confirmation_mail_text
    resale_confirmation_text
    resale_confirmation_mail_text
    resale_ticket_listed_mail_text
    waitlist_confirmation_mail_text
    has_preregistrations
    preregistration_mail_text
    notification_emails
    queue_message
    show_ticket_availabilities
    show_ticket_availabilities_under
    registrations_locked
    registrations_locked_at
    deletable
    requires_payments
    payments_enabled
    require_company_for_bank_transfer
    enable_fundraising
    require_fundraising
    fundraising_mode
    allow_other_charity
    allow_down_payments
    down_payment_percentage
    down_payment_deadline
    ticket_categories {
      id
      sport_type
    }
    tickets {
      id
      title
      allow_reassignments
      allow_exchanges
      allow_resale
      allowable_for_exchanges
      allowable_for_resale
      allow_down_payments
      standard_promotion {
        id
        amount
      }
      resale_promotion {
        id
        title
        amount
      }
      promotions {
        id
        title
        amount
      }
      charity {
        id
        title
      }
    }
    products {
      id
      title
      allow_resale
      allow_down_payments
      allowable_for_resale
      standard_promotion {
        id
        amount
      }
    }
    charities {
      id
      title
      logo_url
      description
    }
    enable_private_resale
    private_resale_start_date
    private_resale_end_date
    enable_public_resale
    public_resale_start_date
    public_resale_end_date
    resale_url
    resale_description
    enable_waitlist
    enable_interest_list
    interest_list {
      id
      opt_in_count
    }
    interest_list_url
    cached_registrations_for_sale_count
    sold_registrations_count
    translations {
      ...TranslationFields
    }
    payment_profile {
      id
      title
      can_create_payments
      enabled_payment_methods
      psp_type
      default
      active
    }
    ticket_number_sequences {
      id
      title
      locked
    }
    enable_tickets
    ticket_attributes
    ticket_image {
      id
      url
    }
    tickets_available_from
    participant_fields {
      id
      scope
      title
      show_on_ticket
    }
  }
`);

export default gql(`
  query GetEventSettings($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      locale
      organisation_vat_number
      event(id: $event_id) {
        ...EventSettingsFields
      }
      mail_permissions {
        ...MailPermissionAttributes
      }
      payment_profiles {
        id
        title
        can_create_payments
        enabled_payment_methods
        psp_type
        default
        active
      }
    }
  }
`);
